import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ada88b42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "second-routerView" }
const _hoisted_2 = { class: "order-detail" }
const _hoisted_3 = { class: "detail" }
const _hoisted_4 = { class: "order" }
const _hoisted_5 = { class: "toUse flex j-s-b" }
const _hoisted_6 = { class: "logo-title" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "state" }
const _hoisted_9 = { class: "serveSet flex a-c" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "serve-content flex j-s-b" }
const _hoisted_12 = { class: "content-left" }
const _hoisted_13 = {
  key: 0,
  class: "time"
}
const _hoisted_14 = { class: "money" }
const _hoisted_15 = { class: "content-right" }
const _hoisted_16 = { class: "actual-pay" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn" }, [
  /*#__PURE__*/_createElementVNode("button", null, "评价"),
  /*#__PURE__*/_createElementVNode("button", null, "再次购买")
], -1))
const _hoisted_18 = { class: "orderId" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title flex" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("p", null, "套餐明细")
], -1))
const _hoisted_20 = { class: "choose" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "option-detail flex" }
const _hoisted_23 = { class: "detail-left" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 0,
  class: "detail-right flex j-e a-c"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 1,
  class: "detail-right flex j-e a-c"
}
const _hoisted_28 = ["onClick"]

import { AbstractEnterpriseServiceTrade } from "@/services/datatype/business/service/trade/AbstractEnterpriseServiceTrade";
import { DefaultWebServiceFactory } from "@/services/webapi/DefaultWebServiceFactory";
import { onMounted, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { OrderStatusName } from "@/services/datatype/business/order/OrderStatusName";
import { EnterpriseServicePackageTrade } from "@/services/datatype/business/service/trade/EnterpriseServicePackageTrade";
import { EnterpriseServiceTypeName } from "@/services/datatype/business/service/EnterpriseServiceTypeName";
import { ElMessage, ElMessageBox } from "element-plus";
import CheckType from "@/utils/CheckType";
import CopyUtils from "@/utils/CopyUtils";
import { ArrowRight } from "@element-plus/icons-vue";
import Throttle from "@/utils/Throttle";

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderDetail',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const $store = useStore();
const bread = reactive({
  ...$store.state.bread.bread,
});
const detailList = reactive([]);
let detailData = reactive({
  ...$store.state.bread.detailData,
});

// 点击发起
const initiat = (item) => {
  console.log(item);
  if (item.price) {
    if (item.count > 0) {
      ElMessageBox.confirm("使用当前服务将扣除一次配额，是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // type: 'warning'
      }).then(() => {
        router.push("/layout/order/choose/" + item.serviceType);
        $store.commit("servicerequest/updateServiceType", item.serviceType);
        $store.commit("servicerequest/updateTradeId", item.tradeId);
      });
    } else {
      ElMessage.error('"配额已用完请重新购买"');
    }
  } else {
    router.push("/layout/order/choose/" + item.serviceType);
    $store.commit("servicerequest/updateServiceType", item.serviceType);
    $store.commit("servicerequest/updateTradeId", item.tradeId);
  }
};
const copyContext = Throttle(() => CopyUtils.copy(bread.orderId), 5000);
const getOrderDetails = async (tradeId) => {
  detailList.splice(0, detailList.length);
  let Promise: Promise<AbstractEnterpriseServiceTrade>;
  Promise = DefaultWebServiceFactory.getInstance()
    .getWebEnterpriseServiceOrderService()
    .findEnterpriseServiceTradeById(tradeId);
  await Promise.then((t) => {
    $store.commit("servicerequest/updateTradableId", t.tradableId);
    bread.orderId = t.regionId;
    $store.commit("bread/updateOrderId", t.regionId);
    if (t instanceof EnterpriseServicePackageTrade) {
      let packageTrade = t as EnterpriseServicePackageTrade;
      packageTrade.serviceTradeInfos.forEach((r) => {
        detailList.push({
          img: r.imgUrls[0].trim(),
          title: r.serviceTitle,
          service: EnterpriseServiceTypeName.getDisplayName(r.serviceType),
          price: r.unitPrice,
          discount: r.discount,
          count: r.remainingServiceQuota,
          serviceType: r.serviceType,
          tradeId: r.enterpriseServiceTradeId,
        });
      });
    }
  });
};

onMounted(() => {
  getOrderDetails(route.params.id);
});

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_breadcrumb, { "separator-icon": _unref(ArrowRight) }, {
      default: _withCtx(() => [
        _createVNode(_component_el_breadcrumb_item, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace('/layout/order')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(bread.orderType), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(bread.orderState), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(bread.orderId), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["separator-icon"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _unref(detailData).logo,
                alt: ""
              }, null, 8, _hoisted_7),
              _createElementVNode("span", null, _toDisplayString(_unref(detailData).name), 1)
            ]),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(OrderStatusName).getDisplayName(_unref(detailData).orderState)), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              src: _unref(CheckType).isImg(_unref(detailData).img),
              alt: ""
            }, null, 8, _hoisted_10),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("h3", null, _toDisplayString(_unref(detailData).title), 1),
                (_unref(detailData).time)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, " 有效期至 " + _toDisplayString(_unref(detailData).time), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_14, "￥" + _toDisplayString(_unref(detailData).originlPrice), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h3", _hoisted_16, "实付款￥" + _toDisplayString(_unref(detailData).price), 1),
                _hoisted_17
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", null, [
              _createTextVNode(" 交易编号："),
              _createElementVNode("span", null, _toDisplayString(bread.orderId), 1),
              _createTextVNode("   丨   "),
              _createElementVNode("span", {
                class: "copy",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(copyContext) && _unref(copyContext)(...args)))
              }, "复制"),
              _createTextVNode("             交易时间： " + _toDisplayString(_unref(detailData).creatTime), 1)
            ])
          ])
        ])
      ]),
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "option flex a-c",
            key: index
          }, [
            _createElementVNode("img", {
              src: _unref(CheckType).isImg(item.img),
              alt: ""
            }, null, 8, _hoisted_21),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("h1", null, _toDisplayString(item.title), 1),
                _createElementVNode("p", null, _toDisplayString(item.service), 1),
                (item.price)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_24, "￥ " + _toDisplayString(item.price), 1))
                  : _createCommentVNode("", true)
              ]),
              (item.price)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("h1", null, "X " + _toDisplayString(item.count ? item.count : 0), 1),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (initiat(item))
                    }, "发起", 8, _hoisted_26)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("h1", null, _toDisplayString(item.discount * 10) + " 折优惠", 1),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (initiat(item))
                    }, "咨询/订购", 8, _hoisted_28)
                  ]))
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})